exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-tabs{display:flex;align-items:center;clear:left;height:24px;margin-top:8px}.navbar-tabs>li+li{margin-left:20px}.navbar-tabs>li>a{display:block;height:24px;line-height:16px;padding-top:2px;border-bottom:3px solid transparent;box-sizing:border-box;color:#444;transition:none}.navbar-tabs>li>a.active,.navbar-tabs>li>a:focus,.navbar-tabs>li>a:hover{border-bottom-color:#4b9fd5}", ""]);

// exports
